import React, { useState, useEffect } from 'react';
import packageInfo from '../../package.json';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import DBService from '../service/DBService';
import '../css/loginpage.css';

function LoginPage({ onLogin }) {
  const navigate = useNavigate();
  const [date, setDate] = useState('');
  const [availableDates, setAvailableDates] = useState([]);
  const [accessCode, setAccessCode] = useState('');
  const [role, setRole] = useState('');
  const toast = React.useRef(null);
  const version = "Version " + packageInfo.version;

  const showToast = (severity, summary, detail) => {
    toast.current.show({ severity, summary, detail, life: 3000 });
  };

  useEffect(() => {
    const fetchDates = async () => {
      try {
        const dates = await DBService.getDistinctDates();
        setAvailableDates(dates);
      } catch (error) {
        console.error('Fehler beim Abrufen der Daten:', error);
        showToast('error', 'Fehler', 'Fehler beim Abrufen der Daten. Bitte versuchen Sie es erneut.');
      }
    };

    fetchDates();
  }, []);

  const handleLogin = async () => {
    if (!accessCode || !role || !date) {
      showToast('warn', 'Unvollständige Angaben', 'Bitte alle Felder ausfüllen');
      return;
    }

    try {
      const isValid = await DBService.validateLogin(date, accessCode, role);
      if (isValid) {
        sessionStorage.setItem('role', role);
        sessionStorage.setItem('date', date);
        onLogin();
        navigate('/module');
        showToast('success', 'Erfolgreich', 'Anmeldung war erfolgreich');
      } else {
        showToast('error', 'Ungültige Daten', 'Ungültige Anmeldedaten');
      }
    } catch (error) {
      console.error('Fehler bei der Anmeldung:', error);
      showToast('error', 'Fehler', 'Fehler bei der Anmeldung. Bitte versuchen Sie es erneut.');
    }
  };

  return (
    <div className="login-page">
      <Toast ref={toast} />
      <div className="login-container">
        <Image src="../img/boz_logo.png" alt="Logo des BOZ Melle" width="100%" />
        <h2 className="login-title">Willkommen beim <br />Talentcheck</h2>
        <p className="login-subtitle">Bitte melden Sie sich an, um fortzufahren</p>
        <Tag className="login-version" severity="contrast" value={version} rounded></Tag>

        <div className="login-field dropdown">
          <label htmlFor="date">Datum auswählen</label>
          <Dropdown
            id="date"
            value={date}
            options={availableDates.map((d) => ({ label: d, value: d }))}
            onChange={(e) => setDate(e.value)}
            placeholder="Datum wählen"
          />
        </div>

        <div className="login-field">
          <label htmlFor="accessCode">Zugangscode</label>
          <InputText
            id="accessCode"
            value={accessCode}
            onChange={(e) => setAccessCode(e.target.value)}
            placeholder="Zugangscode eingeben"
          />
        </div>

        <div className="login-field role-selection">
          <label>Ich bin...</label>
          <div className="button-group">
            <Button
              label="Lehrkraft"
              className={role === 'lehrkraft' ? 'p-button-primary' : 'p-button-outlined'}
              onClick={() => setRole('lehrkraft')}
            />
            <Button
              label="BOZ-Mitarbeitende"
              className={role === 'boz' ? 'p-button-primary' : 'p-button-outlined'}
              onClick={() => setRole('boz')}
            />
          </div>
          <Button
            label="Login"
            icon="pi pi-sign-in"
            onClick={handleLogin}
            className="login-button"
          />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
